import { BlurValue } from './pipelineDefault';


export function isValidBase64ImageUri(val: BlurValue['value']): boolean {
  const regex = /^\s*data:([a-z]+\/[a-z]+(;[a-z-]+=[a-z-]+)?)?(;base64)?,[a-z0-9!$&',()*+,;=\-._~:@/?%\s]*\s*$/i;
  return Boolean(val.toString().match(regex));
}
